import { useState, useEffect } from 'react'
import { useFillQueueStore } from '../store/useFillQueueStore'

// Souhrnný indikátor postupu dotahování (viz doc/plans/to-fill-data-fetching.md, krok 6).
// Mountnuto jednou v App. Zobrazí se jen když fronta běží (active). Fixed pravý dolní roh.

const STATUS_ICON = { pending: '⏳', ok: '✓', skip: '–', aborted: '–' }

// Popisek položky ve frontě. U skupin stanic nese položka ts_id I gh_id — dřív se přes
// `||` ukázalo jen ts_id, takže celý seznam byl "10M_TEMP" pod sebou a nebylo poznat,
// která stanice se zrovna dotahuje. Proto se skládají obě části.
const shortName = (item) => {
  const { ts_id: tsId, gh_id: ghId } = item?.params ?? {}
  return [ghId, tsId].filter(Boolean).join(' · ') || '?'
}

export function FillProgress() {
  const active = useFillQueueStore((s) => s.active)
  const done = useFillQueueStore((s) => s.done)
  const total = useFillQueueStore((s) => s.total)
  const queue = useFillQueueStore((s) => s.queue)
  const label = useFillQueueStore((s) => s.label)
  const cancelAll = useFillQueueStore((s) => s.cancelAll)

  const [open, setOpen] = useState(false)
  const [justDone, setJustDone] = useState(false)

  // Krátké „✓ Hotovo" po doběhnutí.
  useEffect(() => {
    if (active) {
      setJustDone(false)
      return
    }
    if (done === 0 && total === 0) return
    setJustDone(true)
    const t = setTimeout(() => setJustDone(false), 1500)
    return () => clearTimeout(t)
  }, [active, done, total])

  if (!active && !justDone) return null

  const pct = total > 0 ? Math.round((done / total) * 100) : 0

  return (
    <div className="fixed bottom-4 right-4 z-[9999] w-64 rounded-lg border border-gray-300 bg-white shadow-lg text-sm">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-2 px-3 py-2 text-left"
      >
        <span className={active ? 'animate-spin' : 'text-green-600'}>{active ? '⟳' : '✓'}</span>
        <span className="flex-1 truncate">
          {active ? `Načítání ${label()}` : 'Hotovo'}
        </span>
        <span className="text-xs text-gray-400">{open ? '▾' : '▸'}</span>
      </button>

      <div className="h-1 bg-gray-100">
        <div
          className="h-full bg-blue-500 transition-[width]"
          style={{ width: `${active ? pct : 100}%` }}
        />
      </div>

      {open && active && (
        <div className="max-h-56 overflow-y-auto border-t border-gray-100 px-3 py-2">
          <ul className="space-y-1">
            {queue.map((q, i) => (
              <li key={i} className="flex items-center gap-2 text-xs">
                <span className="w-4 text-center">{STATUS_ICON[q.status] ?? '⏳'}</span>
                <span className="truncate text-gray-600" title={shortName(q.item)}>
                  {shortName(q.item)}
                </span>
              </li>
            ))}
          </ul>
          <button
            type="button"
            onClick={cancelAll}
            className="mt-2 w-full rounded border border-gray-300 px-2 py-1 text-xs text-gray-600 hover:border-gray-500"
          >
            Zrušit
          </button>
        </div>
      )}
    </div>
  )
}
